import React, { useState, useEffect } from 'react';
import { handleError } from '../../shared/Functions';
import { $BillingAccountACHTokenCreateDTO, $TokenUpdate, TokensVService } from '../../../services/V2/gozer';
import { TabbedTable } from '../../shared/TabbedTable';
import { Address } from '../../shared/Address';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import RepeatIcon from '@material-ui/icons/Repeat';
import { authProvider } from '../../../services/Security';
import { EditModal } from '../../shared/EditModal';
import { AddModal } from '../../shared/AddModal';
import { AddCCTokenModal } from './tokens/cc/AddCCTokenModal';
import { AchTokensVService, CcTokensVService } from '../../../services/V2/longhorn';

export const Tokens = ({ loading, setLoading, billingAccountId, style }) => {
    const [rowData, setRowData] = useState<any>();
    const [showAddCC, setShowAddCC] = useState<boolean>(false);
    const [showEditCC, setShowEditCC] = useState<boolean>(false);
    const [showAddACH, setShowAddACH] = useState<boolean>(false);
    const [showEditACH, setShowEditACH] = useState<boolean>(false);
    const [canUpdateToken, setCanUpdateToken] = useState<boolean>(false);
    const [canCreateToken, setCanCreateToken] = useState<boolean>(false);
    const [canDeleteToken, setCanDeleteToken] = useState<boolean>(false);
    const tabColumns = [
        [
            { title: 'Card Type', field: 'cardType', editable: 'never' },
            { title: 'Last 4', field: 'last4', editable: 'never' },
            { title: 'Expiration Month', field: 'expirationMonth', editable: 'never' },
            { title: 'Expiration Year', field: 'expirationYear', editable: 'never' },
            { title: 'Recurring?', field: 'recurringPayments', editable: 'never', type: 'boolean' }
        ],
        [
            { title: 'Bank Name', field: 'bankName', editable: 'never' },
            { title: 'Last 4', field: 'last4', editable: 'never' },
            { title: 'Account Type', field: 'achAccountHolderType', editable: 'never', render: rowData => `${rowData.achAccountHolderType} ${rowData.achType}` },
            { title: 'Recurring?', field: 'recurringPayments', editable: 'never', type: 'boolean' }
        ]
    ];
    const tabDetails = [
        [
            {
                tooltip: 'Address',
                render: rowData => (
                    <Address
                        rowData={rowData.rowData}
                        showName={true}
                    />
                )
            }
        ],
        [
            {
                tooltip: 'Address',
                render: rowData => (
                    <Address
                        rowData={rowData.rowData}
                        showName={true}
                    />
                )
            }
        ]
    ]
    const tabActions = [
        [
            {
                icon: () => <AddIcon />,
                tooltip: 'Add CC Token',
                isFreeAction: true,
                onClick: () => setShowAddCC(true),
                disabled: !canCreateToken
            },
            {
                icon: () => <EditIcon />,
                tooltip: 'Edit CC Token',
                onClick: (event, row) => handleShowEditCC(row),
                disabled: !canUpdateToken
            },
            {
                icon: () => <RepeatIcon />,
                tooltip: 'Toggle Reccuring Payments',
                onClick: (event, row) => handleReccurring(row),
                disabled: !canUpdateToken
            }
        ],
        [
            {
                icon: () => <AddIcon />,
                tooltip: 'Add ACH Token',
                isFreeAction: true,
                onClick: () => setShowAddACH(true),
                disabled: !canCreateToken
            },
            {
                icon: () => <EditIcon />,
                tooltip: 'Edit ACH Token',
                onClick: (event, row) => handleShowEditACH(row),
                disabled: !canUpdateToken
            },
            {
                icon: () => <RepeatIcon />,
                tooltip: 'Toggle Reccuring Payments',
                onClick: (event, row) => handleReccurring(row),
                disabled: !canUpdateToken
            },
        ]
    ];

    const tabData = [
        query => {
            return new Promise((resolve, reject) => {
                CcTokensVService.ccTokensVGetAll({
                    pageNumber: (query?.page ?? 0) + 1,
                    numberPerPage: query?.pageSize ?? 5,
                    orderBy: query?.orderBy?.field?.toString() ?? "Last4",
                    orderByDesc: query?.orderDirection === "desc",
                    filters: [{
                        property: "BillingAccountId",
                        value: billingAccountId
                    }]
                }).then((x:any) => {
                    setLoading(false)
                    resolve({
                        data: x.items ?? [],
                        page: query?.page,
                        totalCount: x.numberOfItems ?? 0
                    })
                }).catch(x => {
                    reject(x)
                })
            })
        },
        query => {
            return new Promise((resolve, reject) => {
                AchTokensVService.achTokensVGetAll({
                    pageNumber: (query?.page ?? 0) + 1,
                    numberPerPage: query?.pageSize ?? 5,
                    orderBy: query?.orderBy?.field?.toString() ?? "Last4",
                    orderByDesc: query?.orderDirection === "desc",
                    filters: [{
                        property: "BillingAccountId",
                        value: billingAccountId
                    }]
                }).then((x:any) => {
                    setLoading(false)
                    resolve({
                        data: x.items ?? [],
                        page: query?.page ?? 0,
                        totalCount: x.numberOfItems ?? 0
                    })
                }).catch(x => {
                    reject(x)
                })
            })
        }
    ]

    useEffect(() => {
        let perms = authProvider.getPermissions();
        setCanUpdateToken(perms.some((perm: string) => perm === "UpdateBillingAccounts"));
        setCanCreateToken(perms.some((perm: string) => perm === "UpdateBillingAccounts"));
        setCanDeleteToken(perms.some((perm: string) => perm === "UpdateBillingAccounts"));
    }, []);

    const handleShowEditCC = (row) => {
        setRowData(row)
        setShowEditCC(true);
    }

    const handleReccurring = (row) => {
            TokensVService.tokensVUpdateRecurring(billingAccountId, row.id, !row.recurringPayments)
                .then(x => setLoading(!loading))
                .catch(err => handleError(err))
    }

    const handleShowEditACH = (row) => {
        setRowData(row)
        setShowEditACH(true);
    

    
    }

    return (
        <>
            {showAddCC &&
                <AddCCTokenModal
                    setShow={setShowAddCC}
                    show={showAddCC}
                    setLoading={setLoading}
                    loading={loading}
                    billingAccountId={billingAccountId}
                />}
            {showEditCC &&
                <EditModal
                    modelId={rowData.id}
                    parentId={billingAccountId}
                    parentsParentId={null}
                    data={rowData}
                    modelName="CC Token"
                    setShow={setShowEditCC}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={TokensVService.tokensVUpdate}
                    extraEndpoint={null}
                    deleteEndpoint={TokensVService.tokensVUpdate}
                    viewKeys={null}
                    editKeys={$TokenUpdate.properties}
                    extraKeys={null}
                    hardDelete={canDeleteToken}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showAddACH &&
                <AddModal
                    setShow={setShowAddACH}
                    show={showAddACH}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={TokensVService.tokensVUpdate}
                    keys={$BillingAccountACHTokenCreateDTO.properties}
                    modelName="ACH Token"
                    parentId={billingAccountId}
                    parentsParentId={null}
                    parent={null}
                    parentValues={[]}
                    canReadUserRoles={false}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showEditACH &&
                <EditModal
                    modelId={rowData.id}
                    parentId={billingAccountId}
                    parentsParentId={null}
                    data={rowData}
                    modelName="ACH Token"
                    setShow={setShowEditACH}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={TokensVService.tokensVUpdate}
                    extraEndpoint={null}
                    deleteEndpoint={TokensVService.tokensVUpdate}
                    viewKeys={null}
                    editKeys={$TokenUpdate.properties}
                    extraKeys={null}
                    hardDelete={canDeleteToken}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            <TabbedTable
                tabData={tabData}
                tabColumns={tabColumns}
                tabDetails={tabDetails}
                tabActions={tabActions}
                tabNames={["CC Tokens", "ACH Tokens"]}
                style={style}
            />
        </>
    );
}